import { render, staticRenderFns } from "./getCode.vue?vue&type=template&id=6fd866ae&scoped=true&"
import script from "./getCode.vue?vue&type=script&lang=js&"
export * from "./getCode.vue?vue&type=script&lang=js&"
import style0 from "./getCode.vue?vue&type=style&index=0&id=6fd866ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd866ae",
  null
  
)

export default component.exports